import { buttonActionThemes } from "@streeteasy/design-system/button-action";

export default {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  DARK_BG: buttonActionThemes.DARK_PRIMARY
};
